import { Box, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { Colors } from '../../util/util'
import styles from './styles'

export const BillAmountBreakup = ({
  data,
  borderStyle = 'dashed',
  valueColor = Colors.BLACK_14,
  lableColor = '#757575',
}: any) => {
  const { billAmount, agentFeeAmount, total, chargeAmount } = data ?? {}

  return (
    <Box justifyContent={'space-between'}>
      <Box {...styles.listItemContainer} pv={3}>
        <Box>
          <Text
            fontWeight={'600'}
            color={lableColor as ColorOptions}
            fontSize={14}
            numberOfLines={1}
            fontFamily={'JioType-Medium'}
            lineHeight={26}
            letterSpacing={-0.07}>
            Bill Amount
          </Text>
        </Box>
        <Box align={'flex-start'}>
          <Text
            fontSize={14}
            lineHeight={26}
            selectable
            fontFamily="JioType-Bold"
            color={valueColor as ColorOptions}
            textAlign={'left'}>
            ₹ {billAmount}
          </Text>
        </Box>
      </Box>
      <Box {...styles.listItemContainer} pv={3}>
        <Box>
          <Text
            color={lableColor as ColorOptions}
            fontSize={14}
            lineHeight={26}
            numberOfLines={1}
            fontFamily={'JioType-Medium'}
            letterSpacing={-0.07}>
            Convenience Fee
          </Text>
        </Box>
        <Box align={'flex-start'}>
          <Text
            fontSize={14}
            lineHeight={26}
            selectable
            fontFamily="JioType-Bold"
            color={Colors.BLACK_14 as ColorOptions}
            textAlign={'left'}>
            ₹ {chargeAmount}
          </Text>
        </Box>
      </Box>
      <Box {...styles.listItemContainer} pv={3}>
        <Box>
          <Text
            color={lableColor as ColorOptions}
            fontSize={14}
            lineHeight={26}
            numberOfLines={1}
            fontFamily={'JioType-Medium'}
            letterSpacing={-0.07}>
            Agent Fee
          </Text>
        </Box>
        <Box align={'flex-start'}>
          <Text
            fontSize={14}
            lineHeight={26}
            selectable
            fontFamily="JioType-Bold"
            color={'#00B259' as ColorOptions}
            textAlign={'left'}>
            + ₹ {agentFeeAmount}
          </Text>
        </Box>
      </Box>
      <Spacer size={8} direction={'vertical'} />
      <Box borderTopWidth={1} borderStyle={borderStyle} borderTopColor={'#E0E0E0' as ColorOptions} />
      <Box {...styles.listItemContainer} pt={16} pb={0}>
        <Box>
          <Text
            color={lableColor as ColorOptions}
            fontSize={14}
            numberOfLines={1}
            fontFamily={'JioType-Medium'}
            lineHeight={26}
            letterSpacing={-0.07}>
            Total
          </Text>
        </Box>
        <Box align={'flex-start'}>
          <Text
            fontSize={18}
            lineHeight={24}
            selectable
            fontFamily="JioType-Black"
            color={valueColor as ColorOptions}
            textAlign={'left'}>
            ₹ {total}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
